export { QRSms } from "./qr-sms";
